import { h } from "preact";

const ShareIcon = ({ color = "#788391" }) => {
  return (
    <svg
      width="20px"
      height="17px"
      viewBox="0 0 20 17"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ic_reply</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g
        id="Catalogue/search-page"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="ic_reply"
          transform="translate(10.000000, 8.000000) scale(-1, 1) translate(-10.000000, -8.000000) translate(-3.000000, -5.000000)"
        >
          <g id="Icon-24px">
            <path
              d="M10.8333333,9.75 L10.8333333,5.41666667 L3.25,13 L10.8333333,20.5833333 L10.8333333,16.1416667 C16.25,16.1416667 20.0416667,17.875 22.75,21.6666667 C21.6666667,16.25 18.4166667,10.8333333 10.8333333,9.75 L10.8333333,9.75 Z"
              id="Shape"
              fill={color}
            />
            <polygon id="Shape" points="0 0 26 0 26 26 0 26" />
          </g>
        </g>
      </g>
    </svg>
  );
};
export default ShareIcon;



// WEBPACK FOOTER //
// ./assets/images/ShareIcon.js